"use client"
import { signOut, useSession } from "next-auth/react"
export default function Header({ session }) {
  const user = session?.user
  return (
    <header
      className="w-full bg-white shadow-md px-2 py-2 flex  items-center shadow"
      style={{ marginLeft: "5px", borderBottomLeftRadius: "5px" }}
    >
      <p className="text-xl font-bold text-gray-800 w-full lg:w-auto text-right ">
        Welcome back {user?.name || "User"}!
      </p>
    </header>
  );
}